import React from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { Grid, Box, Typography } from "@mui/material";
import CourseActivityIcon from "../Icons/CourseActivityIcon";
import useMediaQuery from "@mui/material/useMediaQuery";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(4.5),
    paddingBottom: theme.spacing(5.5),
    borderBottom: `solid 1px ${theme.palette.secondary[300]}`,
    width: "100%"
  },
  subtitleDivider: {
    padding: theme.spacing(0, 1, 0, 1),
    [theme.breakpoints.down("lg")]: {
      display: "none"
    }
  },
  buttons: {
    marginTop: theme.spacing(0.75),
    [theme.breakpoints.down("md")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      paddingTop: "24px"
    }
  },
  viewScoreButton: {
    width: theme.spacing(20)
  }
}));

function ResourceViewerHeader(props) {
  const { activityTitle, navigationButtons } = props;
  const classes = useStyles();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  function getIcon() {
    if (props.contentType) {
      return <CourseActivityIcon type={props.contentType} />;
    }
  }

  function getSubtitle() {
    let subtitle = [];
    if (props.subtitle) {
      subtitle.push(
        <Typography variant="body2" className={classes.subtitle} key="0">
          {props.subtitle}
        </Typography>
      );
      subtitle.push(
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.subtitleDivider}
          key="1"
        >
          |
        </Typography>
      );
    }
    return subtitle;
  }

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={0}
        wrap={smallScreen ? "wrap" : "nowrap"}
        justifyContent="space-between"
      >
        <Grid container item xs={12} sm={9}>
          <Box
            display="flex"
            flexDirection="column"
            color={theme.palette.text.secondary}
          >
            <Box display="flex" pr={4} pt={0.75}>
              <Box pt={0.5} pr={3}>
                {getIcon()}
              </Box>
              <Typography variant="h4" align="left">
                {activityTitle}
              </Typography>
            </Box>
            <Box
              pt={0.5}
              pl={6.25}
              display="flex"
              flexDirection={{ xs: "column", lg: "row" }}
            >
              {getSubtitle()}
            </Box>
          </Box>
        </Grid>
        <div className={classes.buttons}>{navigationButtons}</div>
      </Grid>
    </div>
  );
}

export default ResourceViewerHeader;

ResourceViewerHeader.propTypes = {
  courseType: PropTypes.string,
  contentType: PropTypes.string,
  activityTitle: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
